
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import Pager from '@/components/PagerComponent'

import { AccountStatus } from '@/enums/account-status.enum'

import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedDistributorRef: '',
        selectedCommercialProduct: '',
        selectedFunderContract: '',
        selectedBeneficiaryService: '',
        selectedAccountStatus: '',
        selectedCreationDate: ''
      },
      displayedAccounts: [],
      distributors: [],
      comProducts: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      accountStatus: AccountStatus,
      isDistributorLocked: false
    }
  },

  created () {
    if(this.$store.state.accounts.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.accounts.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('accounts/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getProducts(user)
    this.getCriterias(user)
  },

  methods: {
    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.$store.dispatch('accounts/setCriterias', this.criterias)
        this.getAccounts()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedDistributorRef = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getProducts (user) {
      for (const tmpPprdcRefList of Object.values(user.comProductsMap)) {
        this.comProducts = this.comProducts.concat(Object.values(tmpPprdcRefList)[0])
      }
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    async getCriterias (user) {
      if(this.$store.state.accounts.criterias && this.$store.state.accounts.accounts.length > 0) {
        this.criterias = this.$store.state.accounts.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedDistributorRef = user.ihmDistribRef
      }
    },

    updateComProducts () {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.comProducts = Object.values(user.comProductsMap[this.criterias.selectedDistributorRef])[0]
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    async getAccounts () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('accounts/reset')
      await this.$store.dispatch('accounts/search', {
        distributorRef: this.criterias.selectedDistributorRef,
        issuerId: this.getIssuerId(this.criterias.selectedDistributorRef),
        funderContractRef: this.criterias.selectedFunderContract,
        beneficiaryServiceRef: this.criterias.selectedBeneficiaryService,
        productRef: this.criterias.selectedCommercialProduct,
        accountStatus: this.criterias.selectedAccountStatus,
        creationDate: this.criterias.selectedCreationDate
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
        }
      )
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    async showDetails (account) {
      this.$store.dispatch('accounts/setAccount', account)
      this.$router.push({ name: 'account-detail' })
    },

    reset () {
      this.$store.dispatch('accounts/reset')
      this.$store.dispatch('accounts/resetCriterias')
      this.validationError = false
      this.error = false
      if (!this.isDistributorLocked) {
        this.criterias.selectedDistributorRef = ''
      }
      this.criterias.selectedFunderContract = ''
      this.criterias.selectedCommercialProduct = ''
      this.criterias.selectedBeneficiaryService = ''
      this.criterias.selectedAccountStatus = ''
      this.criterias.selectedCreationDate = ''
    }
  },

  validations() {
    return {
      criterias: {
        selectedDistributorRef: { required },
        selectedCommercialProduct: {},
        selectedFunderContract: {},
        selectedBeneficiaryService: {},
        selectedAccountStatus: {},
        selectedCreationDate: {}
      }
    }
  }
}
